export default __webpack_public_path__ + "static/media/videoHome2.7d8d58c9.mp4";